module.exports = __webpack_public_path__ + "static/media/lesson.2c3075ec.svg";